import React from 'react';

import styles from './userCompensationsPageStyles';

const DeleteDraftCompensationButton = ({ id, destroyCompensation }) => (
  <button
    onClick={() => {
      destroyCompensation(id);
    }}
    className={styles.deleteDraftButton}
  >
    x Delete Draft
  </button>
);

export default DeleteDraftCompensationButton;
